
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/section/indices",
      function () {
        return require("private-next-pages/section/indices.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/section/indices"])
      });
    }
  